export const createCounterTopUrl = (path) => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['countertops-base-api-url'];
  return `${baseUrl}/${path}`;
};

export default createCounterTopUrl;
